export default __webpack_public_path__ + "static/media/icon2.041771bd.svg";